export const PROFILE_API_TYPES = {
  nonProp: 'API_TYPE: NONPROP',
  prop: 'API_TYPE: PROP',
  platform: 'API_TYPE: PLATFORM'
};

export const BASE_PATH_BY_API_TYPE = {
  [PROFILE_API_TYPES.prop]: '/tiaa-proprietary-funds/v1',
  [PROFILE_API_TYPES.platform]: '/screener/v1/screens/'
};
